import Action from './baseActions';
import {IRole, ApiParams} from '../../models';

export enum RolesActionTypes {
  LOAD_ROLES = 'roles/load',
  LOADING_ROLES = 'roles/loading',
  LOADED_ROLES = 'roles/loaded',
  LOADING_ROLES_FAILED = 'roles/loading_failed',

  LOAD_ROLE = 'roles/load_role',
  LOADING_ROLE = 'roles/loading_role',
  LOADED_ROLE = 'roles/loaded_role',
  LOADING_ROLE_FAILED = 'roles/loading_role_failed',

  CREATE_ROLE = 'roles/create',
  CREATING_ROLE = 'roles/creating',
  CREATED_ROLE = 'roles/created',
  CREATING_ROLE_FAILED = 'roles/creating_failed',

  UPDATE_ROLE = 'roles/update',
  UPDATING_ROLE = 'roles/updating',
  UPDATED_ROLE = 'roles/updated',
  UPDATING_ROLE_FAILED = 'roles/updating_failed',

  DELETE_ROLE = 'roles/delete',
  DELETING_ROLE = 'roles/deleting',
  DELETED_ROLE = 'roles/deleted',
  DELETING_ROLE_FAILED = 'roles/deleting_failed',

  // assign role to users
  ASSIGN_ROLE = 'roles/assign',
  ASSIGNING_ROLE = 'roles/assigning',
  ASSIGNED_ROLE = 'roles/assigned',
  ASSIGNING_ROLE_FAILED = 'roles/assigning_failed',

  // revoke role from users
  REVOKE_ROLE = 'roles/revoke',
  REVOKING_ROLE = 'roles/revoking',
  REVOKED_ROLE = 'roles/revoked',
  REVOKING_ROLE_FAILED = 'roles/revoking_failed',
}

// Interfaces
interface RoleParams extends ApiParams {
  reload?: boolean;
}

export interface ILoadRolesAction extends Action {
  type: RolesActionTypes.LOAD_ROLES;
  payload?: RoleParams;
}

export interface ILoadingRolesAction extends Action {
  type: RolesActionTypes.LOADING_ROLES;
}

export interface ILoadedRolesAction extends Action {
  type: RolesActionTypes.LOADED_ROLES;
  payload: {
    roles: IRole[];
    reload: boolean;
    page_size: number;
  };
}

export interface ILoadingRolesFailedAction extends Action {
  type: RolesActionTypes.LOADING_ROLES_FAILED;
}

export interface ILoadRoleAction extends Action {
  type: RolesActionTypes.LOAD_ROLE;
  payload: string;
}

export interface ILoadingRoleAction extends Action {
  type: RolesActionTypes.LOADING_ROLE;
}

export interface ILoadedRoleAction extends Action {
  type: RolesActionTypes.LOADED_ROLE;
  payload: IRole;
}

export interface ILoadingRoleFailedAction extends Action {
  type: RolesActionTypes.LOADING_ROLE_FAILED,
}

export interface ICreateRoleAction extends Action {
  type: RolesActionTypes.CREATE_ROLE;
  payload: {
    name: string;
  }
}

export interface ICreatingRoleAction extends Action {
  type: RolesActionTypes.CREATING_ROLE;
}

export interface ICreatedRoleAction extends Action {
  type: RolesActionTypes.CREATED_ROLE;
  payload: IRole;
}

export interface ICreatingRoleFailedAction extends Action {
  type: RolesActionTypes.CREATING_ROLE_FAILED,
}

export interface IUpdateRoleAction extends Action {
  type: RolesActionTypes.UPDATE_ROLE;
  payload: {
    uid: string;
    name: string;
  }
}

export interface IUpdatingRoleAction extends Action {
  type: RolesActionTypes.UPDATING_ROLE;
}

export interface IUpdatedRoleAction extends Action {
  type: RolesActionTypes.UPDATED_ROLE;
  payload: IRole;
}

export interface IUpdatingRoleFailedAction extends Action {
  type: RolesActionTypes.UPDATING_ROLE_FAILED,
}

export interface IDeleteRoleAction extends Action {
  type: RolesActionTypes.DELETE_ROLE;
  payload: string;
}

export interface IDeletingRoleAction extends Action {
  type: RolesActionTypes.DELETING_ROLE;
}

export interface IDeletedRoleAction extends Action {
  type: RolesActionTypes.DELETED_ROLE;
  payload: string;
}

export interface IDeletingRoleFailedAction extends Action {
  type: RolesActionTypes.DELETING_ROLE_FAILED,
}

export interface IAssignRoleAction extends Action {
  type: RolesActionTypes.ASSIGN_ROLE;
  payload: {
    uid: string; // role uid
    usersUid: string[];
  }
}

export interface IAssigningRoleAction extends Action {
  type: RolesActionTypes.ASSIGNING_ROLE;
}

export interface IAssignedRoleAction extends Action {
  type: RolesActionTypes.ASSIGNED_ROLE;
  payload: any;
}

export interface IAssigningRoleFailedAction extends Action {
  type: RolesActionTypes.ASSIGNING_ROLE_FAILED;
}

export interface IRevokeRoleAction extends Action {
  type: RolesActionTypes.REVOKE_ROLE;
  payload: {
    uid: string; // role uid
    usersUid: string[];
  }
}

export interface IRevokingRoleAction extends Action {
  type: RolesActionTypes.REVOKING_ROLE;
}

export interface IRevokedRoleAction extends Action {
  type: RolesActionTypes.REVOKED_ROLE;
  payload: any;
}

export interface IRevokingRoleFailedAction extends Action {
  type: RolesActionTypes.REVOKING_ROLE_FAILED;
}

// Functions

export function loadRoles(properties?: RoleParams): ILoadRolesAction {
  return {
    type: RolesActionTypes.LOAD_ROLES,
    payload: properties || {},
  };
}

export function loadingRoles(): ILoadingRolesAction {
  return {
    type: RolesActionTypes.LOADING_ROLES
  };
}

export function loadedRoles(roles: IRole[], reload: boolean = false, page_size: number = 0): ILoadedRolesAction {
  return {
    type: RolesActionTypes.LOADED_ROLES,
    payload: {
      roles,
      page_size,
      reload,
    }
  };
}

export function loadingRolesFailed(): ILoadingRolesFailedAction {
  return {
    type: RolesActionTypes.LOADING_ROLES_FAILED
  }
}

export function loadRole(uid: string): ILoadRoleAction {
  return {
    type: RolesActionTypes.LOAD_ROLE,
    payload: uid,
  }
}

export function loadingRole(): ILoadingRoleAction {
  return {
    type: RolesActionTypes.LOADING_ROLE,
  }
}

export function loadedRole(role: IRole): ILoadedRoleAction {
  return {
    type: RolesActionTypes.LOADED_ROLE,
    payload: role,
  }
}

export function loadingRoleFailed(): ILoadingRoleFailedAction {
  return {
    type: RolesActionTypes.LOADING_ROLE_FAILED,
  }
}

export function createRole(name: string): ICreateRoleAction {
  return {
    type: RolesActionTypes.CREATE_ROLE,
    payload: {
      name,
    }
  }
}

export function creatingRole(): ICreatingRoleAction {
  return {
    type: RolesActionTypes.CREATING_ROLE,
  }
}

export function createdRole(role: IRole): ICreatedRoleAction {
  return {
    type: RolesActionTypes.CREATED_ROLE,
    payload: role,
  }
}

export function creatingRoleFailed(): ICreatingRoleFailedAction {
  return {
    type: RolesActionTypes.CREATING_ROLE_FAILED,
  }
}

export function updateRole(uid: string, name: string): IUpdateRoleAction {
  return {
    type: RolesActionTypes.UPDATE_ROLE,
    payload: {
      uid,
      name,
    }
  }
}

export function updatingRole(): IUpdatingRoleAction {
  return {
    type: RolesActionTypes.UPDATING_ROLE,
  }
}

export function updatedRole(role: IRole): IUpdatedRoleAction {
  return {
    type: RolesActionTypes.UPDATED_ROLE,
    payload: role,
  }
}

export function updatingRoleFailed(): IUpdatingRoleFailedAction {
  return {
    type: RolesActionTypes.UPDATING_ROLE_FAILED,
  }
}

export function deleteRole(uid: string): IDeleteRoleAction {
  return {
    type: RolesActionTypes.DELETE_ROLE,
    payload: uid,
  }
}

export function deletingRole(): IDeletingRoleAction {
  return {
    type: RolesActionTypes.DELETING_ROLE,
  }
}

export function deletedRole(uid: string): IDeletedRoleAction {
  return {
    type: RolesActionTypes.DELETED_ROLE,
    payload: uid,
  }
}

export function deletingRoleFailed(): IDeletingRoleFailedAction {
  return {
    type: RolesActionTypes.DELETING_ROLE_FAILED,
  }
}

export function assignRole(uid: string, usersUid: string[]): IAssignRoleAction {
  return {
    type: RolesActionTypes.ASSIGN_ROLE,
    payload: {
      uid,
      usersUid,
    }
  }
}

export function assigningRole(): IAssigningRoleAction {
  return {
    type: RolesActionTypes.ASSIGNING_ROLE,
  }
}

export function assignedRole(result: any): IAssignedRoleAction {
  return {
    type: RolesActionTypes.ASSIGNED_ROLE,
    payload: result,
  }
}

export function assigningRoleFailed(): IAssigningRoleFailedAction {
  return {
    type: RolesActionTypes.ASSIGNING_ROLE_FAILED,
  }
}

export function revokeRole(uid: string, usersUid: string[]): IRevokeRoleAction {
  return {
    type: RolesActionTypes.REVOKE_ROLE,
    payload: {
      uid,
      usersUid,
    }
  }
}

export function revokingRole(): IRevokingRoleAction {
  return {
    type: RolesActionTypes.REVOKING_ROLE,
  }
}

export function revokedRole(result: any): IRevokedRoleAction {
  return {
    type: RolesActionTypes.REVOKED_ROLE,
    payload: result,
  }
}

export function revokingRoleFailed(): IRevokingRoleFailedAction {
  return {
    type: RolesActionTypes.REVOKING_ROLE_FAILED,
  }
}

export type RolesAction =
  ILoadRolesAction |
  ILoadingRolesAction |
  ILoadedRolesAction |
  ILoadingRolesFailedAction |
  ILoadRoleAction |
  ILoadingRoleAction |
  ILoadedRoleAction |
  ILoadingRoleFailedAction |
  ICreateRoleAction |
  ICreatingRoleAction |
  ICreatedRoleAction |
  ICreatingRoleFailedAction |
  IUpdateRoleAction |
  IUpdatingRoleAction |
  IUpdatedRoleAction |
  IUpdatingRoleFailedAction |
  IDeleteRoleAction |
  IDeletingRoleAction |
  IDeletedRoleAction |
  IDeletingRoleFailedAction |
  IAssignRoleAction |
  IAssigningRoleAction |
  IAssignedRoleAction |
  IAssigningRoleFailedAction |
  IRevokeRoleAction |
  IRevokingRoleAction |
  IRevokedRoleAction |
  IRevokingRoleFailedAction;
